'use client';

import Link from 'next/link';

// Root error boundary — before this existed, any render error anywhere was an
// unstyled dead end. Keep it dependency-light (it must not itself throw).
export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md text-center space-y-5">
        <h1 className="text-3xl font-bold">Something went sideways</h1>
        <p className="text-muted-foreground">
          That wasn&apos;t supposed to happen. Try again, or head somewhere solid.
        </p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={reset}
            className="px-5 py-2.5 rounded-lg bg-slate-900 text-white font-medium hover:bg-slate-800 transition-colors"
          >
            Try again
          </button>
          <Link
            href="/"
            className="px-5 py-2.5 rounded-lg border-2 border-slate-200 font-medium hover:bg-slate-50 transition-colors"
          >
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}
